import { useMutation } from '@tanstack/react-query'
import { useApiClientUser } from '~/@api/client/useApiClientUser'
import type { IResetPasswordRequest } from '~/@api/generated-api-types-user/Api'
import { getApiErrorMessage } from '~/@lib/utils/error.utils'

function useResetPassword() {
  const client = useApiClientUser()

  const resetPasswordMutation = useMutation({
    mutationFn: async (props: IResetPasswordRequest) => {
      return await client.user
        .authControllerResetPassword(props, { secure: true })
        .then((res) => res.data)
    },
  })

  return {
    resetPassword: resetPasswordMutation.mutate,
    isRequesting: resetPasswordMutation.isPending,
    error: getApiErrorMessage(
      resetPasswordMutation.error,
      'Heslo sa nepodarilo zmeniť.'
    ),
    handleReset: resetPasswordMutation.reset,
  }
}

export { useResetPassword }
